import React, { useEffect } from "react";
import SelectAutoComplete from "components/SelectAutocomplete";
import {
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useEspelhoVendas } from "services/api/AppWeb_EspelhoVendas";
import { BsFileLock } from "react-icons/bs";
import * as Styles from "./styles";
import SelectComponent from "../../../../../selectAutoCompleteG";

// interface ProductSelectProps {
//   value: string;
//   label: string;
//   codigoSap: string;
// }

// interface SelectProps {
//   value: string;
//   label: string;
// }

// interface DataProps {
//   bandeira: SelectProps;
//   bloco: SelectProps;
//   produto: ProductSelectProps;
// }
interface Props {
  data: any;
  dataResumo: any;
  blocosData: any;
}

const ProductCard: React.FC<Props> = (props) => {
  const [block, setBlock] = React.useState<any>({
    label: props?.data?.bloco?.label || "",
    value: props?.data?.bloco?.value || "",
  });

  const { refetch: refetchEspelhoVendas } = useEspelhoVendas({
    queryKey: "espelho_vendas",
    codigoSap: props?.data?.produto?.codigoSap,
    nomeBloco: block?.label,
  });

  useEffect(() => {
    if (block) {
      refetchEspelhoVendas();
    }
  }, [block]);

  return (
    <div
      style={{
        display: "flex",
        gap: "48px",
        paddingBottom: "4px",
        borderBottom: "1px solid #D5D5D5",
      }}
    >
      <Styles.Container>
        <Styles.Column flex={1}>
          <Styles.StrongText>{props?.data?.produto?.label}</Styles.StrongText>
          <div
            style={{
              display: "flex",
              gap: "8px",
              marginTop: "8px",
              alignItems: "center",
            }}
          >
            <Styles.LightText>Bloco: </Styles.LightText>
            {/* <Styles.LightText>{props?.data?.bloco?.label} </Styles.LightText> */}
            <SelectComponent
              borderRadius="8px"
              data={
                props?.blocosData?.data?.map((item: any) => ({
                  label: item?.nome,
                  value: item?.id,
                })) || []
              } // Garantir que seja um array vazio caso seja undefined
              value={block || {}}
              onChange={(event: { label: string; value: string }) => {
                setBlock(event || {});
              }}
            />
          </div>
        </Styles.Column>
      </Styles.Container>
      <div>
        {props.dataResumo?.resumos?.resumoEmpresaVendas ? (
          <Table
            aria-label="simple table"
            sx={{
              border: "1px solid #D5D5D5",
              borderRadius: "8px",
              overflow: "hidden",
              borderCollapse: "separate",
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    padding: "4px 16px",
                  }}
                >
                  <Styles.TableTextHeader>
                    Empresa de venda
                  </Styles.TableTextHeader>
                </TableCell>
                <TableCell
                  sx={{
                    padding: "4px 16px",
                  }}
                >
                  <Styles.TableTextHeader>Qtd.</Styles.TableTextHeader>
                </TableCell>
                <TableCell
                  sx={{
                    padding: "4px 16px",
                  }}
                >
                  <Styles.TableTextHeader>%</Styles.TableTextHeader>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.dataResumo?.resumos?.resumoEmpresaVendas?.map(
                (item: any) => (
                  <TableRow key={item?.id}>
                    <TableCell
                      sx={{
                        padding: "4px 16px",
                        backgroundColor: `rgb(${item.corFundo})`,
                      }}
                    >
                      <Styles.TableTextBody>{item?.nome}</Styles.TableTextBody>
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "4px 16px",
                      }}
                    >
                      <Styles.TableTextBody style={{ color: "#475467" }}>
                        {item?.quantidade}
                      </Styles.TableTextBody>
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "4px 16px",
                      }}
                    >
                      <Styles.TableTextBody style={{ color: "#475467" }}>
                        {item?.porcent}
                      </Styles.TableTextBody>
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        ) : (
          <Styles.LightText>Carregando...</Styles.LightText>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
